import React from 'react';
import { BookOpen, Hammer, Award, Briefcase } from 'lucide-react';

const steps = [
  {
    n: '01',
    icon: <BookOpen className="w-5 h-5" />,
    label: 'Learn',
    sub: 'AI + Future Skills',
    img: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=900&h=1100&fit=crop&q=80',
    accent: 'from-violet-600/80 via-violet-700/40 to-transparent',
    chip: 'bg-violet-500/90'
  },
  {
    n: '02',
    icon: <Hammer className="w-5 h-5" />,
    label: 'Build Projects',
    sub: 'Real Industry Work',
    img: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=900&h=1100&fit=crop&q=80',
    accent: 'from-blue-600/80 via-blue-700/40 to-transparent',
    chip: 'bg-blue-500/90'
  },
  {
    n: '03',
    icon: <Award className="w-5 h-5" />,
    label: 'Get Certified',
    sub: 'Dual Industry Certificates',
    img: 'https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?w=900&h=1100&fit=crop&q=80',
    accent: 'from-amber-600/80 via-amber-700/40 to-transparent',
    chip: 'bg-amber-500/90'
  },
  {
    n: '04',
    icon: <Briefcase className="w-5 h-5" />,
    label: 'Freelance / Get Hired',
    sub: 'Launch Your Career',
    img: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900&h=1100&fit=crop&q=80',
    accent: 'from-emerald-600/80 via-emerald-700/40 to-transparent',
    chip: 'bg-emerald-500/90'
  }
];

const TransformationJourney = () => (
  <section data-testid="transformation-journey" className="relative py-20 px-6 overflow-hidden" style={{ background: 'radial-gradient(ellipse at bottom, #0a0d24 0%, #050614 60%, #000 100%)' }}>
    {/* Decorative timeline rail behind cards */}
    <div className="absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent hidden md:block"></div>
    <div className="absolute top-10 left-1/4 w-[400px] h-[400px] bg-violet-500/15 rounded-full blur-[140px]"></div>
    <div className="absolute bottom-10 right-1/4 w-[400px] h-[400px] bg-amber-500/15 rounded-full blur-[140px]"></div>

    <div className="container mx-auto max-w-7xl relative">
      <div className="text-center mb-14">
        <p className="text-xs font-bold uppercase tracking-[0.4em] text-yellow-400 mb-3">Your Transformation Journey</p>
        <h2 className="text-3xl md:text-5xl font-black text-white leading-tight">
          From <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 via-amber-300 to-emerald-400">Curious Beginner</span> to <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-emerald-400">Career-Ready Pro</span>
        </h2>
        <p className="text-sm md:text-base text-gray-400 mt-3 max-w-xl mx-auto">A clear 4-step path. Real outcomes. No fluff.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {steps.map((s, i) => (
          <div
            key={i}
            data-testid={`journey-step-${i}`}
            className="group relative rounded-2xl overflow-hidden border border-white/10 hover-lift cursor-default"
            style={{ aspectRatio: '4 / 5' }}
          >
            <img src={s.img} alt={s.label} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" decoding="async" fetchPriority="high" />
            <div className={`absolute inset-0 bg-gradient-to-t ${s.accent}`}></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20"></div>

            {/* step number top-left */}
            <div className="absolute top-3 left-3 text-xs font-mono font-black tracking-widest text-white/70">{s.n}</div>

            {/* icon chip */}
            <div className={`absolute top-3 right-3 w-9 h-9 rounded-full ${s.chip} flex items-center justify-center text-white shadow-lg`}>
              {s.icon}
            </div>

            {/* content overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
              <h3 className="text-lg md:text-2xl font-black text-white leading-tight">{s.label}</h3>
              <p className="text-xs md:text-sm text-white/80 mt-1">{s.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TransformationJourney;
